/**
 * Content page types for legal/info pages
 */
export var ContentType;
(function (ContentType) {
    ContentType["PRIVACY_POLICY"] = "PRIVACY_POLICY";
    ContentType["TERMS_OF_SERVICE"] = "TERMS_OF_SERVICE";
    ContentType["COOKIE_POLICY"] = "COOKIE_POLICY";
    ContentType["DATA_PROCESSING_AGREEMENT"] = "DATA_PROCESSING_AGREEMENT";
    ContentType["FAQ"] = "FAQ";
    ContentType["ABOUT"] = "ABOUT";
    ContentType["HELP_ARTICLE"] = "HELP_ARTICLE";
    ContentType["ANNOUNCEMENT"] = "ANNOUNCEMENT";
    ContentType["CUSTOM"] = "CUSTOM";
})(ContentType || (ContentType = {}));
/**
 * Content page publication status
 */
export var ContentStatus;
(function (ContentStatus) {
    ContentStatus["DRAFT"] = "DRAFT";
    ContentStatus["PUBLISHED"] = "PUBLISHED";
    ContentStatus["ARCHIVED"] = "ARCHIVED";
})(ContentStatus || (ContentStatus = {}));
